import { useState, type FormEvent } from "react";
import Reveal from "./Reveal";

const submitAddr = "https://readdy.ai/api/form/dag3hqptto0ceqqnhl0g";

const contactChannels = [
  { icon: "ri-mail-line", label: "投稿邮箱", value: "tip@tianya-chigua.example" },
  { icon: "ri-chat-3-line", label: "合作洽谈", value: "hello@tianya-chigua.example" },
  { icon: "ri-time-line", label: "响应时效", value: "工作日 24 小时内" },
  { icon: "ri-shield-check-line", label: "信息保密", value: "绝不公开投稿人信息" },
];

export default function ContactSection() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = fd.get("contact_alt");
    if (typeof honeypot === "string" && honeypot.trim() !== "") {
      setStatus("success");
      setMsg("收到！感谢你的反馈，我们会尽快处理。");
      form.reset();
      return;
    }
    const cleanFd = new FormData();
    fd.forEach((value, key) => {
      if (key !== "contact_alt" && value !== "") cleanFd.append(key, value);
    });
    try {
      const res = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(cleanFd as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || "";
      if (res.ok && parsed?.code === "OK" && !/spam/i.test(text)) {
        setStatus("success");
        setMsg("投稿已收到！我们会交叉核实后整理入库，感谢你的分享。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络开小差了，请稍后重试。");
    }
  };

  return (
    <section id="submit" className="bg-background-50 py-16 md:py-24">
      <div className="section-wrap grid grid-cols-1 gap-10 lg:grid-cols-[0.95fr_1.05fr]">
        <Reveal>
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> SUBMIT & CONTACT
            </p>
            <h2 className="font-serif-editorial mt-3 text-3xl font-black text-foreground-950 md:text-4xl">
              投稿线索 · 联系我们
            </h2>
            <p className="mt-5 leading-8 text-foreground-600">
              如果你掌握了一手线索，或是发现档案存在偏差，欢迎告诉我们。
              我们会先做事实核查与信源比对，确认可靠后整理入库，并严格保护你的隐私。
            </p>

            <div className="mt-8 flex flex-col gap-3">
              {contactChannels.map((c) => (
                <div
                  key={c.label}
                  className="flex items-center gap-4 rounded-2xl border border-background-200 bg-background-100 px-5 py-4"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-600 text-lg text-white">
                    <i className={c.icon}></i>
                  </span>
                  <div>
                    <p className="text-sm text-foreground-500">{c.label}</p>
                    <p className="font-semibold text-foreground-900">{c.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <form
            onSubmit={onSubmit}
            data-readdy-form="dag3hqptto0ceqqnhl0g"
            className="rounded-3xl border border-background-200 bg-background-100 p-6 md:p-8"
          >
            <div className="flex items-center gap-2 text-lg font-bold text-foreground-900">
              <i className="ri-quill-pen-line text-primary-600"></i>
              投递你的瓜
            </div>
            <p className="mt-1 text-sm text-foreground-500">填得越清楚，越方便我们快速核实。</p>

            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <label className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-foreground-700">怎么称呼你</span>
                <input
                  name="name"
                  type="text"
                  placeholder="你的昵称"
                  className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm outline-none transition-colors focus:border-primary-400"
                />
              </label>
              <label className="flex flex-col gap-1.5">
                <span className="text-sm font-medium text-foreground-700">联系邮箱（选填）</span>
                <input
                  name="email"
                  type="email"
                  placeholder="you@example.com"
                  className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm outline-none transition-colors focus:border-primary-400"
                />
              </label>
            </div>

            <label className="mt-4 flex flex-col gap-1.5">
              <span className="text-sm font-medium text-foreground-700">事件 / 线索标题</span>
              <input
                name="subject"
                type="text"
                placeholder="一句话说清你想投递的事件"
                className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm outline-none transition-colors focus:border-primary-400"
              />
            </label>

            <label className="mt-4 flex flex-col gap-1.5">
              <span className="text-sm font-medium text-foreground-700">线索详情</span>
              <textarea
                name="message"
                rows={5}
                maxLength={500}
                placeholder="请尽量描述事件背景、关键时间节点与信源，方便我们核实（500 字以内）"
                className="w-full resize-none rounded-xl border border-background-300 bg-background-50 px-4 py-3 text-sm leading-6 outline-none transition-colors focus:border-primary-400"
              ></textarea>
            </label>

            {/* honeypot */}
            <div className="field-captcha-guard">
              <input
                name="contact_alt"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                readOnly
                aria-hidden="true"
              />
            </div>

            <button
              type="submit"
              className="mt-6 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-6 py-3.5 text-[15px] font-medium text-white transition-colors hover:bg-primary-700"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </button>

            {status === "success" && (
              <p className="mt-4 flex items-center gap-2 rounded-xl bg-secondary-100 px-4 py-3 text-sm text-secondary-800">
                <i className="ri-checkbox-circle-fill text-lg"></i>
                {msg}
              </p>
            )}
            {status === "error" && (
              <p className="mt-4 flex items-center gap-2 rounded-xl bg-primary-100 px-4 py-3 text-sm text-primary-800">
                <i className="ri-error-warning-line text-lg"></i>
                {msg}
              </p>
            )}
          </form>
        </Reveal>
      </div>
    </section>
  );
}